/** 挂载到 modal 实例的生命周期事件名 */
export const MODAL_EVENTS = [
  'beforeModal',
  'init',
  'afterModal',
  'beforeCloseModal',
  'afterCloseModal',
] as const;

/** modalDataEvent 模式下从 data 剥离的事件字段 */
export const DATA_EVENTS = ['onOK', 'onCancel'] as const;

export type ModalEventName = typeof MODAL_EVENTS[number];
